import React from "react";
import ModalLayout from "../../../components/ModalLayout";
import { Box, Typography, useTheme } from "@mui/material";
import ShieldTickSVG from "../../../../media/images/icons/shield-tick";
import CustomButton from "../../../components/CustomButton";
import { useNavigate } from "react-router-dom";
import ArrowLeftCircle from "../../../../media/images/icons/arrow-left-circle";

interface Props {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  mobileNumber: string;
}

export default function HandleSuccessForgetPassModal(props: Props) {
  const { open, setOpen, mobileNumber } = props;

  const navigate = useNavigate();

  const theme = useTheme();
  return (
    <ModalLayout open={open} setOpen={setOpen}>
      <Box
        sx={{
          borderRadius: "8px",
          backgroundColor: "success.light",
          display: "flex",
          alignItems: "center",
          padding: "8px",
          justifyContent: "center",
        }}
      >
        <ShieldTickSVG size={24} color={theme.palette.success.main} />
        <Typography
          sx={{
            color: "success.main",
            fontSize: "14px",
          }}
        >
          بازیابی رمز عبور با موفقیت انجام شد
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
          }}
        >
          رمز عبور جدید به شماره
        </Typography>
        <Typography
          sx={{
            fontSize: "18px",
            direction: "ltr",
            fontWeight: "700",
            color: "primary.main",
          }}
        >
          {mobileNumber}
        </Typography>
        <Typography
          sx={{
            fontSize: "14px",
          }}
        >
          ارسال شد.
        </Typography>
      </Box>
      <CustomButton
        // loading={loginMutating}
        onClick={() => navigate("/login")}
        flexDirection="row"
        title="بازگشت به صفحه ورود"
        justifyContent="center"
        bgColor={theme.palette.secondary.main}
        fSize="16px"
        fWeight="700"
        px="20px"
        py="10px"
        borderRadius="6px"
        textColor="#fff"
        icon2={<ArrowLeftCircle color={"#fff"} size={28} />}
        mt="16px"
      />
    </ModalLayout>
  );
}
